import { isIn } from "../utils/index.mjs";
export const Matchers = tag => keys => {
  const inKeys = isIn(keys);

  const match = (match, def) => a => (match[a[tag]] || def)(a);

  const transform = match => a => {
    const c = match[a[tag]];
    return c ? c(a) : a;
  };

  const fold = a => a;

  const createReducer = initialState => (m, def) => {
    const matcher = match(m, def);
    return (s, a) => {
      const state = s === undefined ? initialState : s;
      return inKeys(a[tag]) ? matcher(a)(state) : state;
    };
  };

  return {
    matchStrict: match,
    match,
    transform,
    fold,
    createReducer,
    strict: a => a
  };
};
//# sourceMappingURL=index.mjs.map